/* eslint-disable */
/* eslint-disable prefer-const */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable no-debugger */
/* eslint-disable prefer-const */
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { ReactComponent as Uploading } from '../../assets/images/cloud-uploading.svg';
import BlueCard from './blueCard';
import WhiteCard from './whiteCard';
import { Usercontext } from './searchResults';
import { GetEmployeeID, GetRole } from '../../../api/user';
import CurrencyInput from 'react-currency-input-field';
// import { AgreementContext } from '../../../context/AgreementContext';
import { addedItemStyles } from '../../componentstyles/addedItemStyles';
// import {agreementStyle} from './Test';
import TwoFactorComponent from '../../Shared/secondAuthen';
// import Erroricon from '../../../assets/images/erroricon.png';
import { PackagePriceContext } from '../../../context/PackagePriceTagContext';
import { ReactComponent as Erroricon } from '../../../assets/images/error-icon.svg';
import { InventoryMajorContext } from '../../../context/inventoryMajorContext';

import {
  RACTextbox,
  RACSelect,
  RACModalCard,
  RACButton,
  Grid,
  Card,
  CardContent,
  Typography,
  RACChip,
} from '@rentacenter/racstrap';
import { ContainerContext } from '../../../app/App';
import { CustomPropInterface } from '../../../index';
import { getValidNumber } from '../../../utils/legalPriceUtils';
import { ADD_ON_PACKAGE } from '../../../constants/constants';
import { useTranslation } from 'react-i18next';
const AddedItem = (props: any) => {
  const containerData = useContext(ContainerContext) as CustomPropInterface;
  const classes = props.throwStyle;
  const addedItemClassName = addedItemStyles();
  const shareData: any = useContext(Usercontext);
  const { initialAgrData, initialAgrTerm } = useContext(PackagePriceContext);
  const { priceOverrideLimitDetails, setPriceOverrideLimitDetails, termOverrideLimitDetails, MXStoreIdentifier } = useContext(InventoryMajorContext)
  const [SecondFactorEnabled, setSecondFactorEnabled] = useState(false);
  const {t} = useTranslation('SearchResults');
  const SLAObj = {
    TwoFactorCancelClick: false,
    TwoFactorCompleted: false,
  };
  const needSLAObj = {
    needSLAController: false,
  };
  const [percentCalculation, setpercentCalculation] = useState(0);
  const [SLAController, setSLAController] = useState(SLAObj);
  const [needSLA, setneedSLA] = React.useState(needSLAObj);
  const [thresHoldExceptionMessage, setthresHoldExceptionMessage] = useState<any>('');
  const [initialAgreementRate, setinitialAgreementRate] = useState<any>();
  const [initialAgreementTerm, setIntialAgreementTerm] = useState<any>();
  const [invalidTermPopup, setInvalidTermPopup] = useState(false)

  const [agrRate, setagrRate]: any = useState('0.00');
  const [agrTerm, setagrTerm] = useState('0.00');
  const [openRateAlertModal, setopenRateAlertModal] = useState(false);
  const [openTermAlertModal, setopenTermAlertModal] = useState(false);
  const [mxRateIncreasePopup, setMxRateIncreasePopup] = useState(false);

  const [agrTotal, setAgrTotal] = useState('0.00');
  const [cashPrice, setCashPrice] = useState('0.00');
  const [slaOverrideInvalid, setslaOverrideInvalid] = useState('');
  const [conditionLoader, setconditionLoader] = useState<boolean>(true);
  const [enableZeroValidate, setenableZeroValidate] = React.useState(false);
  const [invalidTerm, setinvalidTerm] = React.useState(false);
  const [slaErrorMessage, setslaErrorMessage] = useState('')
  const [controlCurrencyInput, setcontrolCurrencyInput] = React.useState(false);
  const [SLAMinRole, setSLAMinRole] = useState('');
  const ModuleName = 'Edit AgmtRt W/O Competitor';
  const [CurrentRole, setCurrentRole] = useState('');

  const [controlCompetitor, setControlCompetitor] = useState(true);
  const [roleFromSLA, setroleFromSLA] = useState('');
  //const [pricedata, setpricedata] = React.useState([]);
  const [proof, setproof] = useState('');
  const [checkedState, setcheckedState] = useState(false);
  const [throwPackageValue, setthrowPackageValue] = useState<any>();

  const configDataObj = priceOverrideLimitDetails
  const configTermDataObj = termOverrideLimitDetails
  const [configData, setConfigData] = useState<any>(configDataObj);
  const [termValidationConfigData, settermValidationConfigData] = useState<any>(configTermDataObj)

  useEffect(() => {
    const GettingRole = async () => {
      const GetcurrentUser = await GetEmployeeID();
      console.log('GetcurrentUser', GetcurrentUser);
      if (GetcurrentUser.status === 200) {
        const GetcurrentUserResponse = GetcurrentUser.data;
        const EmployeeId = GetcurrentUserResponse.employeeId;
        const GetMenuPayload = {
          coworkerId: EmployeeId,
        };
        const GetMenuDetails: any = await GetRole(GetMenuPayload);
        console.log('GetMenuDetails', GetMenuDetails);
        if (GetMenuDetails.status === 200) {
          const GetMenuDetailsResponse = GetMenuDetails.data;
          const currentRole = GetMenuDetailsResponse.coworkerProfile.role;
          console.log('currentRole', currentRole);
          setCurrentRole(currentRole);
        }
      }
    };
    // GettingRole();
    if (containerData !== undefined) {
      console.log('containerData', containerData);
      console.log('containerDataRole', containerData.GetRole());
      setCurrentRole(containerData.GetRole());
    } else {
      GettingRole();
    }
  }, []);

  useEffect(() => {
    console.log('before if condition', props.priceexceptionMessage);
    setthrowPackageValue(props.throwPackage);
    if (
      props.priceexceptionMessage !== null &&
      props.priceexceptionMessage !== undefined
    ) {
      console.log(
        'inside props data of price exception',
        props.priceexceptionMessage
      );
      handleExceptionRevert();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.priceexceptionMessage, props.throwPackage]);
  // eslint-disable-next-line sonarjs/cognitive-complexity
  useEffect(() => {
    if (shareData !== undefined) {
      console.log('Added Item Shared Data', shareData, shareData.itemPricing[0].packageName?.toLowerCase() == ADD_ON_PACKAGE.toLowerCase());
      setagrRate(shareData.agreementPricing.agreementRate);
      setagrTerm(shareData.agreementPricing.agreementTerm);
      setAgrTotal(shareData.agreementPricing.agreementTotal);
      setCashPrice(shareData.agreementPricing.cashPrice);
      if (initialAgrData === undefined) {
        // setinitialAgrData(shareData.agreementPricing.agreementRate);
        setinitialAgreementRate(shareData.agreementPricing.agreementRate);
        setIntialAgreementTerm(shareData?.agreementPricing?.agreementTerm)

      } else {
        setinitialAgreementRate(initialAgrData);
        setIntialAgreementTerm(initialAgrTerm);

      }
        if (initialAgrData !== undefined) {
          setinitialAgreementRate(initialAgrData);
          setIntialAgreementTerm(initialAgrTerm);

      }
    } else {
      setagrRate('');
      setagrTerm('');
      setAgrTotal('');
      setCashPrice('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proof, shareData, initialAgrData, initialAgrTerm]); // this method is used to validate the proof //PS-8

  const agrRatechange = (AgrRate: any) => {
    setagrRate(AgrRate);
  };
  // this method will store the new agr Rate value

  const agrTermchange = (AgrTerm: any) => {
    setagrTerm(AgrTerm);
  }; // this method will store the new agr Term value

  const handleExceptionRevert = () => {
    if (shareData !== undefined) {
      setagrRate(shareData.agreementPricing.agreementRate);
      setagrTerm(shareData.agreementPricing.agreementTerm);
    }
  };
  const closeInvalidTermAndRate = () => {
    setDefault();
    setinvalidTerm(false);
    setenableZeroValidate(false);
  };

  const blurFunction = (functionController: any): any => {
    console.log('checking agrrate', agrRate);
    console.log('initialAgreementRate', initialAgreementRate);
    console.log(
      'checking shareData.agreementPricing.agreementRate',
      shareData.agreementPricing.agreementRate
    );

    if (
      functionController == 'RateChange' &&
      Number(agrRate) !== Number(shareData.agreementPricing.agreementRate)
    ) {
      const values = Object.values(configDataObj);
      const maxValues = values
        .filter((value): value is { min: number; max: number } => typeof value === 'object' && value !== null && 'max' in value)
        .map(v => (v.max === null || v.max === undefined || isNaN(v.max)) ? 0 : v.max); // Treat null, undefined, NaN as 0
      const maxPercentageEdit = maxValues.length > 0 ? Math.max(...maxValues) : 0;
      
      // Calculate min percentage for rate decrease validation
      const minValues = values
        .filter((value): value is { min: number; max: number } => typeof value === 'object' && value !== null && 'min' in value)
        .map(v => (v.min === null || v.min === undefined || isNaN(v.min)) ? 0 : v.min); // Treat null, undefined, NaN as 0
      const minPercentageEdit = minValues.length > 0 ? Math.max(...minValues) : 0;
      
      const maxAllowablbeLimit = (Number(initialAgreementRate) * Number(maxPercentageEdit)) / 100
      const minAllowableLimit = (Number(initialAgreementRate) * Number(minPercentageEdit)) / 100
      let percentCalculationInBlur: any
      percentCalculationInBlur = Math.abs(
        ((initialAgreementRate - agrRate) * 100) / initialAgreementRate
      );
      percentCalculationInBlur = (Math.floor(Number(percentCalculationInBlur) * 100) / 100).toFixed(2)
      setpercentCalculation(Number(percentCalculationInBlur));

      if (Number(agrRate) <= Number(initialAgreementRate)) {
        console.log('success reach of if in rate chage');

        let minRole = '';
        let enteredIf = false;
        let output;

        const Roles = [
          'FSC-CAR',
          'CAR',
          'RPMT',
          'FSC-AM',
          'AM',
          'FSC-LAM',
          'LAM',
          'FSC-SMT',
          'SMT',
          'FSC-SM',
          'SM',
          'FSC-SSM',
          'SSM',
          'CAM',
          'FSC-DMT',
          'DMT',
          'FSC-DM',
          'DM',
          'FSC-RDT',
          'RDT',
          'FSC-RD',
          'RD'
        ];

        if (Number(minPercentageEdit) < Number(percentCalculationInBlur)) {

          if (CurrentRole == 'RD' || CurrentRole == 'FSC-RD' || CurrentRole == 'RDT' || CurrentRole == 'FSC-RDT') {
            setopenRateAlertModal(true)
            setslaErrorMessage(`${t('Rate is invalid. Allowable Rate Values are')} $${Number(Number(initialAgreementRate) - minAllowableLimit).toFixed(2)} ${t('to')} $${Number(initialAgreementRate).toFixed(2)}`)
          }
          else {
            setopenRateAlertModal(true)
            setslaErrorMessage(`${t('Override is invalid. SLA user can override from')} $${Number(Number(initialAgreementRate) - minAllowableLimit).toFixed(2)} ${t('to')} $${Number(initialAgreementRate).toFixed(2)}`)
          }
        }
        else {
          for (const item in configDataObj) {

            if (
              configData[item]?.min == Number(percentCalculationInBlur).toFixed(2) &&
              Number(percentCalculationInBlur) !== 0
            ) {

              minRole = item;
              output = item;
              setSLAMinRole(item);
              if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
                setneedSLA({ ...needSLA, needSLAController: true });
                enteredIf = true;
              }
              break;
            } else if (configData[item]?.min > Number(percentCalculationInBlur)) {

              minRole = item;
              output = item
              setSLAMinRole(item);
              if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
                setneedSLA({ ...needSLA, needSLAController: true });
                enteredIf = true;
              }
              break;
            }
          }

          console.log('logged roles', CurrentRole);

    
          const groupedData: { [key: string]: string[] } = {};

          for (const [key, value] of Object.entries(configData)) {
            const stringValue = String((value as { min: number; max: number })?.min); // Convert min value to string
            if (!groupedData[stringValue]) {
              groupedData[stringValue] = [key];
            } else {
              groupedData[stringValue].push(key);
            }
          }

          console.log("groupedData", groupedData)
          let currentRoleValue: any;

          for (const key of Object.keys(groupedData)) {
            if (groupedData[key].includes(CurrentRole)) {
              // Convert key to number if needed
              currentRoleValue = parseInt(key);
              // Once we find the  role, we can break the loop
              break;
            }
          }

          console.log("currentRoleValue", currentRoleValue)

          let allowedRate;
          let minAmount;
          allowedRate = Number(initialAgreementRate) * (1 * currentRoleValue / 100);
          minAmount = Number(initialAgreementRate) - allowedRate;
          setthresHoldExceptionMessage(
            `Coworker can only change rate upto $${Number(
              minAmount.toString()
            ).toFixed(2)}. second level approval is required for this change.`
          );

          if (enteredIf === false) {
            console.log('entered if pricing call', enteredIf);

            Number(agrRate) < 1
              ? setenableZeroValidate(true)
              : props.setreceiveAgreementRate(agrRate);
          }
        }
      } else {
        // Rate increase validation using max values
        console.log('Rate increase detected');
        
        // MX Store check - cannot increase rate for MX stores
        if (MXStoreIdentifier === "1") {
          setMxRateIncreasePopup(true);
          return;
        }
        
        // If maxPercentageEdit is 0 or NaN, no rate increase is allowed at all
        if (maxPercentageEdit === 0 || isNaN(maxPercentageEdit)) {
          console.log('Blocking rate increase - maxPercentageEdit is 0 or NaN:', maxPercentageEdit);
          
          // Calculate min allowable rate based on highest role's min limit
          const minValuesForZeroMax = values
            .filter((value): value is { min: number; max: number } => typeof value === 'object' && value !== null && 'min' in value)
            .map(v => (v.min === null || v.min === undefined || isNaN(v.min)) ? 0 : v.min);
          const maxMinPercentageForZeroMax = minValuesForZeroMax.length > 0 ? Math.max(...minValuesForZeroMax) : 0;
          const minAllowableRateForZeroMax = Number(initialAgreementRate) - (Number(initialAgreementRate) * Number(maxMinPercentageForZeroMax) / 100);
          
          setopenRateAlertModal(true);
          if (CurrentRole == 'RD' || CurrentRole == 'FSC-RD' || CurrentRole == 'RDT' || CurrentRole == 'FSC-RDT') {
            setslaErrorMessage(`${t('Rate is invalid. Allowable Rate Values are')} $${Number(minAllowableRateForZeroMax).toFixed(2)} ${t('to')} $${Number(initialAgreementRate).toFixed(2)}`);
          } else {
            setslaErrorMessage(`${t('Override is invalid. SLA user can override from')} $${Number(minAllowableRateForZeroMax).toFixed(2)} ${t('to')} $${Number(initialAgreementRate).toFixed(2)}`);
          }
          return;
        }
        
        // Check current role's max value - if 0 or NaN, current role cannot increase rate on their own
        const currentRoleMaxConfig = configData[CurrentRole]?.max;
        const currentRoleMaxValue = (currentRoleMaxConfig === null || currentRoleMaxConfig === undefined || isNaN(currentRoleMaxConfig)) ? 0 : currentRoleMaxConfig;
        console.log('Current role max config:', CurrentRole, currentRoleMaxValue);
        
        // If current role's max is 0 or less than the requested percentage, check if SLA is needed
        if (currentRoleMaxValue === 0 || currentRoleMaxValue < Number(percentCalculationInBlur)) {
          console.log('Current role max is insufficient, checking for SLA...');
          
          const RolesForSLA = [
            'FSC-CAR', 'CAR', 'RPMT', 'FSC-AM', 'AM', 'FSC-LAM', 'LAM',
            'FSC-SMT', 'SMT', 'FSC-SM', 'SM', 'FSC-SSM', 'SSM', 'CAM',
            'FSC-DMT', 'DMT', 'FSC-DM', 'DM', 'FSC-RDT', 'RDT', 'FSC-RD', 'RD'
          ];
          
          // Find the first role (in hierarchy order) that has max >= percentCalculationInBlur
          let foundRoleWithMax = '';
          for (const role of RolesForSLA) {
            const roleMax = configData[role]?.max;
            const roleMaxValue = (roleMax === null || roleMax === undefined || isNaN(roleMax)) ? 0 : roleMax;
            if (roleMaxValue >= Number(percentCalculationInBlur)) {
              foundRoleWithMax = role;
              break;
            }
          }
          
          console.log('Found role with sufficient max:', foundRoleWithMax);
          
          if (foundRoleWithMax) {
            // Check if the found role is higher than current role (needs SLA)
            if (RolesForSLA.indexOf(String(CurrentRole)) < RolesForSLA.indexOf(foundRoleWithMax)) {
              // A higher role can approve this - show SLA
              setSLAMinRole(foundRoleWithMax);
              setneedSLA({ ...needSLA, needSLAController: true });
              
              const roleMax = configData[foundRoleWithMax]?.max || 0;
              const maxAmount = Number(initialAgreementRate) + (Number(initialAgreementRate) * roleMax / 100);
              setthresHoldExceptionMessage(
                `Coworker can only change rate upto $${Number(maxAmount).toFixed(2)}. Second level approval is required for this change.`
              );
              return;
            } else {
              // Current role or lower role can handle it - allow the change
              console.log('Current role or lower can handle, allowing change');
              Number(agrRate) < 1
                ? setenableZeroValidate(true)
                : props.setreceiveAgreementRate(agrRate);
              return;
            }
          } else {
            // No role can handle this percentage - show error
            const minValuesCalc = values
              .filter((value): value is { min: number; max: number } => typeof value === 'object' && value !== null && 'min' in value)
              .map(v => (v.min === null || v.min === undefined || isNaN(v.min)) ? 0 : v.min);
            const maxMinPercent = minValuesCalc.length > 0 ? Math.max(...minValuesCalc) : 0;
            const minAllowableRateCalc = Number(initialAgreementRate) - (Number(initialAgreementRate) * maxMinPercent / 100);
            const maxAllowableRateCalc = Number(initialAgreementRate) + (Number(initialAgreementRate) * maxPercentageEdit / 100);
            
            setopenRateAlertModal(true);
            if (CurrentRole == 'RD' || CurrentRole == 'FSC-RD' || CurrentRole == 'RDT' || CurrentRole == 'FSC-RDT') {
              setslaErrorMessage(`${t('Rate is invalid. Allowable Rate Values are')} $${Number(minAllowableRateCalc).toFixed(2)} ${t('to')} $${Number(maxAllowableRateCalc).toFixed(2)}`);
            } else {
              setslaErrorMessage(`${t('Override is invalid. SLA user can override from')} $${Number(minAllowableRateCalc).toFixed(2)} ${t('to')} $${Number(maxAllowableRateCalc).toFixed(2)}`);
            }
            return;
          }
        }
        
        let minRole = '';
        let enteredIf = false;
        let output;

        const Roles = [
          'FSC-CAR',
          'CAR',
          'RPMT',
          'FSC-AM',
          'AM',
          'FSC-LAM',
          'LAM',
          'FSC-SMT',
          'SMT',
          'FSC-SM',
          'SM',
          'FSC-SSM',
          'SSM',
          'CAM',
          'FSC-DMT',
          'DMT',
          'FSC-DM',
          'DM',
          'FSC-RDT',
          'RDT',
          'FSC-RD',
          'RD'
        ];

        // Calculate max allowable rate based on highest role's max limit
        const maxAllowableRate = Number(initialAgreementRate) + (Number(initialAgreementRate) * Number(maxPercentageEdit) / 100);
        // Calculate min allowable rate based on highest role's min limit
        const minValues = values
          .filter((value): value is { min: number; max: number } => typeof value === 'object' && value !== null && 'min' in value)
          .map(v => (v.min === null || v.min === undefined || isNaN(v.min)) ? 0 : v.min); // Treat null, undefined, NaN as 0
        const maxMinPercentageEdit = minValues.length > 0 ? Math.max(...minValues) : 0;
        const minAllowableRate = Number(initialAgreementRate) - (Number(initialAgreementRate) * Number(maxMinPercentageEdit) / 100);

        if (Number(maxPercentageEdit) < Number(percentCalculationInBlur)) {
          // Percentage exceeds even the highest role's max limit
          if (CurrentRole == 'RD' || CurrentRole == 'FSC-RD' || CurrentRole == 'RDT' || CurrentRole == 'FSC-RDT') {
            setopenRateAlertModal(true)
            setslaErrorMessage(`${t('Rate is invalid. Allowable Rate Values are')} ${Number(minAllowableRate).toFixed(2)} ${t('to')} ${Number(maxAllowableRate).toFixed(2)}`)
          }
          else {
            setopenRateAlertModal(true)
            setslaErrorMessage(`${t('Override is invalid. SLA user can override from')} ${Number(minAllowableRate).toFixed(2)} ${t('to')} ${Number(maxAllowableRate).toFixed(2)}`)
          }
        }
        else {
          // Check role-based max limits for rate increase
          for (const item in configDataObj) {        
            if (
              configData[item]?.max == Number(percentCalculationInBlur).toFixed(2) &&
              Number(percentCalculationInBlur) !== 0
            ) {

              minRole = item;
              output = item;
              setSLAMinRole(item);
              if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
                setneedSLA({ ...needSLA, needSLAController: true });
                enteredIf = true;
              }
              break;
            } else if (configData[item]?.max > Number(percentCalculationInBlur)) {
              
              minRole = item;
              output = item
              setSLAMinRole(item);
              if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
                setneedSLA({ ...needSLA, needSLAController: true });
                enteredIf = true;
              }
              break;
            }
          }

          console.log('logged roles for rate increase', CurrentRole);
      
          const groupedData: { [key: string]: string[] } = {};

          for (const [key, value] of Object.entries(configData)) {
            const stringValue = String((value as { min: number; max: number })?.max); // Convert max value to string
            if (!groupedData[stringValue]) {
              groupedData[stringValue] = [key];
            } else {
              groupedData[stringValue].push(key);
            }
          }

          console.log("groupedData for rate increase", groupedData)
          let currentRoleValue: any = 0;
          for (const key of Object.keys(groupedData)) {
            if (groupedData[key].includes(CurrentRole)) {
              currentRoleValue = parseFloat(key) || 0;
              break;
            }
          }
          
          // Fallback: get max value directly from configData for current role
          if (currentRoleValue === 0 && configData[CurrentRole]?.max) {
            currentRoleValue = configData[CurrentRole].max;
          }

          console.log("currentRoleValue for rate increase", currentRoleValue)

          let allowedRate;
          let maxAmount;
          allowedRate = Number(initialAgreementRate) * (currentRoleValue / 100);
          maxAmount = Number(initialAgreementRate) + allowedRate;

          console.log("check here",initialAgreementRate, currentRoleValue, allowedRate, maxAmount );
          

          setthresHoldExceptionMessage(
            `Coworker can only change rate upto ${Number(
              maxAmount
            ).toFixed(2)}. second level approval is required for this change.`
          );

          if (enteredIf === false) {
            console.log('entered if pricing call for rate increase', enteredIf);

            Number(agrRate) < 1
              ? setenableZeroValidate(true)
              : props.setreceiveAgreementRate(agrRate);
          }
        }
      }

    } else if (
      functionController == 'TermChange' &&
      agrTerm !== shareData.agreementPricing.agreementTerm
    ) {
      const maximumAllowedTermLimit =
        getValidNumber(props?.maximumAllowedTerm) ??
        getValidNumber(shareData?.agreementPricing?.maximumAllowedTerm) ??
        getValidNumber(initialAgreementTerm);

      const values = Object.values(configTermDataObj);
      const maxValues = values
        .filter((value): value is { min: number; max: number } => typeof value === 'object' && value !== null && 'max' in value)
        .map(v => (v.max === null || v.max === undefined || isNaN(v.max)) ? 0 : v.max); // Treat null, undefined, NaN as 0
      const maxPercentageEdit = maxValues.length > 0 ? Math.max(...maxValues) : 0;
      
      // Calculate min percentage for term decrease validation
      const minValues = values
        .filter((value): value is { min: number; max: number } => typeof value === 'object' && value !== null && 'min' in value)
        .map(v => (v.min === null || v.min === undefined || isNaN(v.min)) ? 0 : v.min); // Treat null, undefined, NaN as 0
      const minPercentageEdit = minValues.length > 0 ? Math.max(...minValues) : 0;
      
      const maxAllowablbeLimit = (Number(initialAgreementTerm) * Number(maxPercentageEdit)) / 100
      const minAllowableLimit = (Number(initialAgreementTerm) * Number(minPercentageEdit)) / 100
      const percentCalculationInBlur = Math.abs(
        Math.ceil(((Number(initialAgreementTerm) - Number(agrTerm)) * 100) / Number(initialAgreementTerm))
      );
      console.log("percentCalculationInBlurCheck", percentCalculationInBlur)

      let minRole = '';
      let enteredIf = false;
      let output;

      const Roles = [
        'FSC-CAR',
        'CAR',
        'RPMT',
        'FSC-AM',
        'AM',
        'FSC-LAM',
        'LAM',
        'FSC-SMT',
        'SMT',
        'FSC-SM',
        'SM',
        'FSC-SSM',
        'SSM',
        'CAM',
        'FSC-DMT',
        'DMT',
        'FSC-DM',
        'DM',
        'FSC-RDT',
        'RDT',
        'FSC-RD',
        'RD'
      ];
      if (
        Number(agrTerm) < Number(10) ||
        (maximumAllowedTermLimit !== undefined &&
          Number(agrTerm) > maximumAllowedTermLimit)
      ) {
        setInvalidTermPopup(true)
      }
      else if (Number(minPercentageEdit) < Number(percentCalculationInBlur)) {
        if (CurrentRole == 'RD' || CurrentRole == 'FSC-RD' || CurrentRole == 'RDT' || CurrentRole == 'FSC-RDT') {
          setopenTermAlertModal(true)
          setslaErrorMessage(`${t('Term is invalid. Allowable Term Values are')} ${Math.ceil(Number(initialAgreementTerm) - minAllowableLimit)} ${t('to')} ${Number(initialAgreementTerm)}`)
          return

        }
        else {
          setopenTermAlertModal(true)
          setslaErrorMessage(`${t('Override is invalid. SLA user can override from')} ${Math.ceil(Number(initialAgreementTerm) - minAllowableLimit)} ${t('to')} ${Number(initialAgreementTerm)}`)
          return
        }
      }
      else {
        for (const item in configTermDataObj) {

          if (
            termValidationConfigData[item]?.min == Number(percentCalculationInBlur).toFixed(2) &&
            Number(percentCalculationInBlur) !== 0
          ) {
            minRole = item;
            output = item;
            setSLAMinRole(item);
            if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
              setneedSLA({ ...needSLA, needSLAController: true });
              enteredIf = true;
            }
            break;
          } else if (termValidationConfigData[item]?.min > Number(percentCalculationInBlur)) {

            minRole = item;
            output = item
            setSLAMinRole(item);

            if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
              setneedSLA({ ...needSLA, needSLAController: true });
              enteredIf = true;
            }
            break;
          }
        }

        console.log('logged roles', CurrentRole);

        const groupedData: { [key: string]: string[] } = {};

        for (const [key, value] of Object.entries(termValidationConfigData)) {
          const stringValue = String((value as { min: number; max: number })?.min); // Convert min value to string
          if (!groupedData[stringValue]) {
            groupedData[stringValue] = [key];
          } else {
            groupedData[stringValue].push(key);
          }
        }

        console.log("groupedData", groupedData)
        let currentRoleValue: any;
        for (const key of Object.keys(groupedData)) {
          if (groupedData[key].includes(CurrentRole)) {
            // Convert key to number if needed
            currentRoleValue = parseInt(key);
            // Once we find the  role, we can break the loop
            break;
          }
        }
        console.log("currentRoleValue", currentRoleValue)

        let allowedRate;
        let minAmount: any;
        allowedRate = initialAgreementTerm * (1 * currentRoleValue / 100);
        minAmount = initialAgreementTerm - allowedRate;
        setthresHoldExceptionMessage(
          `Coworker can only change term upto ${Number(
            Math.ceil(minAmount.toString())
          )} second level approval is required for this change.`
        );
        if (enteredIf === false) {
          console.log('entered if pricing call', enteredIf);
          props.setreceiveAgreementTerm(agrTerm);
        }
      }
    }
  };

  const RateTermChange = (stateController: any, e?: any) => {
    if (
      e.key == 'Enter' &&
      stateController == 'RateChange' &&
      agrRate !== shareData.agreementPricing.agreementRate
    ) {
      // {
      (document.getElementById('AgrRate') as HTMLInputElement).blur();
      // parseInt(agrRate) < 1
      //   ? setinvalidTerm(true)
      //   : props.setreceiveAgreementRate(agrRate);
      // }
    } else if (
      e.key == 'Enter' &&
      stateController == 'TermChange' &&
      agrTerm !== shareData.agreementPricing.agreementTerm
    ) {
      // {
      (document.getElementById('AgrTerm') as HTMLInputElement).blur();
      //   parseInt(agrTerm) < 1
      //     ? setinvalidTerm(true)
      //     : props.setreceiveAgreementTerm(agrTerm);
      // }
      if (checkedState) {
        setcontrolCurrencyInput(true);
      }
    }
  };

  const temp = (itemID: any) => {
    props.triggeroneDelete(itemID);
  };

  const setDefault = () => {
    //alert('Hello');
    if (shareData !== undefined) {
      setagrRate(shareData.agreementPricing.agreementRate);
      setagrTerm(shareData.agreementPricing.agreementTerm);
    }

    setcheckedState(false);
    setcontrolCurrencyInput(false);
    props.triggerSetToDefault();
    setControlCompetitor(true);
  }; // this method will store the default  agr Term and Rate value //PS-7

  // const closeZeroValidate = () => {
  //   setDefault();
  //   setenableZeroValidate(false);
  // };

  const invalidTermDiv = (displayData: any) => {
    return (
      <div
        id="decisionengine"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="decisionengine"
        aria-hidden="true"
      >
        {/* <div className="modal-dialog">
  
              <div className="modal-content"> */}

        <Grid item md={12} className={classes.textCenter}>
          <Typography className={`${classes.fontSemiBold} ${classes.fs6}`}>
            {t(displayData)}
          </Typography>
        </Grid>

        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            size="large"
            variant="contained"
            color="primary"
            onClick={() => closeInvalidTermAndRate()}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const SLACancel = () => {
    setSLAController({ ...SLAController, TwoFactorCancelClick: false });
    setSecondFactorEnabled(false);
    setagrRate(shareData.agreementPricing.agreementRate);
    setagrTerm(shareData?.agreementPricing?.agreementTerm);

  };
  const SLACompleted = (value: any) => {
    setSLAController({ ...SLAController, TwoFactorCompleted: value });
    setSecondFactorEnabled(false);
  };

  const acceptSLA = () => {
    setneedSLA({ ...needSLA, needSLAController: false });
    setSecondFactorEnabled(true);
  };

  const SLAModal = (displayData: any) => {
    return (
      <div id="decisionengine">
        <Grid item md={12} className={classes.textCenter}>
          <Typography className={`${classes.fontSemiBold} ${classes.fs6}`}>
            {t(displayData)}
          </Typography>
          <Typography className={`${classes.fontSemiBold} ${classes.fs6}`}>
            {t('Do you want to proceed ?')}
          </Typography>
        </Grid>

        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.me3}
            size="large"
            variant="outlined"
            color="secondary"
            onClick={() => {
              setneedSLA({ ...needSLA, needSLAController: false });
              setagrRate(shareData.agreementPricing.agreementRate);
              setagrTerm(shareData?.agreementPricing?.agreementTerm)
            }}
          >
            {t('No')}
          </RACButton>
          <RACButton
            className={classes.mx1}
            size="large"
            variant="contained"
            color="primary"
            onClick={() => acceptSLA()}
          >
            {t('Yes')}
          </RACButton>
        </Grid>
      </div>
    );
  };

  // useEffect(() => {
  //   if (SLAController.TwoFactorCompleted) {
  //     parseInt(agrRate) < 1
  //       ? setinvalidTerm(true)
  //       : props.setreceiveAgreementRate(agrRate);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [SLAController.TwoFactorCompleted]);

  useEffect(() => {
    console.log(
      'SLAController.TwoFactorCompleted',
      SLAController.TwoFactorCompleted
    );
    console.log('percentCalculation in use efect', percentCalculation);

    if (SLAController.TwoFactorCompleted) {
      // parseInt(agrRate) < 1
      //   ? setinvalidTerm(true)
      //   :
      if (Number(agrRate) !== Number(shareData.agreementPricing.agreementRate)) {
        props.setreceiveAgreementRate(agrRate);

      }
      else if (Number(agrTerm) !== Number(shareData?.agreementPricing?.agreementTerm)) {
        props.setreceiveAgreementTerm(agrTerm);
      }
    }
    //  else if (SLAController.TwoFactorCompleted && roleFromSLA == '008') {
    //   // parseInt(agrRate) < 1
    //   //   ? setinvalidTerm(true)
    //   //   : props.setreceiveAgreementRate(agrRate);
    //   console.log('expected point reached');

    //   props.setreceiveAgreementRate(agrRate);
    // }
    // else if (SLAController.TwoFactorCompleted && percentCalculation > 50) {
    //   console.log('reached the alert log');
    //   const allowedRate = Math.round(agrRate * 0.5);
    //   const minAmount = agrRate - allowedRate;
    //   setslaOverrideInvalid(
    //     `Override is invalid. SLA user can override from $${minAmount} to $${agrRate}`
    //   );
    //   setopenRateAlertModal(true);
    //   //alert('Override is invalid. SLA user can override from');
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SLAController.TwoFactorCompleted]);
  const acceptRateAlert = () => {
    setopenRateAlertModal(false);
    setagrRate(shareData.agreementPricing.agreementRate);
  };
  const openRateAlert = () => {
    return (
      <div>
        <Grid className={classes.textCenter}>
          {slaErrorMessage.includes('Allowable') ? null : <Erroricon className={classes.racErrorIcon} />}
          <Typography className={classes.racErrorFunction} style={{ fontSize: '16px' }}>
            {slaErrorMessage}
          </Typography>
        </Grid>
        <Grid className={classes.textCenter} style={{ marginTop: '20px' }}>
          <RACButton
            autoFocus
            variant="contained"
            color="primary"
            className={classes.spacerME2}
            onClick={acceptRateAlert}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const acceptTermAlertUser = () => {
    setopenTermAlertModal(false);
    setagrTerm(shareData.agreementPricing.agreementTerm);
  };

  const openRateAlertUser = () => {
    return (
      <div>
        <Grid className={classes.textCenter}>
          {slaErrorMessage.includes('Allowable') ? null : <Erroricon className={classes.racErrorIcon} />
          }
          <Typography className={classes.racErrorFunction} style={{ fontSize: '16px' }}>
            {slaErrorMessage}
          </Typography>
        </Grid>
        <Grid className={classes.textCenter} style={{ marginTop: '20px' }}>
          <RACButton
            autoFocus
            variant="contained"
            color="primary"
            className={classes.spacerME2}
            onClick={acceptTermAlertUser}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </div>
    );
  };


  const acceptTermAlert = () => {
    setInvalidTermPopup(false);
    setagrTerm(shareData?.agreementPricing?.agreementTerm);
  }

  const acceptMxRateIncreaseAlert = () => {
    setMxRateIncreasePopup(false);
    setagrRate(shareData.agreementPricing.agreementRate);
  }

  const openMxRateIncreaseAlert = () => {
    return (
      <div>
        <Grid className={classes.textCenter}>
          <Typography className={classes.racErrorFunction} style={{ fontSize: '16px', paddingRight: '20px' }}>
            {t('Rate is invalid')}
          </Typography>
        </Grid>
        <Grid className={classes.textCenter} style={{ marginTop: '20px' }}>
          <RACButton
            autoFocus
            variant="contained"
            color="primary"
            className={classes.spacerME2}
            onClick={acceptMxRateIncreaseAlert}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </div>
    );
  }

  const openTermAlert = () => {
    const maximumAllowedTermForMessage =
      getValidNumber(props?.maximumAllowedTerm) ??
      getValidNumber(shareData?.agreementPricing?.maximumAllowedTerm) ??
      getValidNumber(initialAgreementTerm) ??
      10;

    return (
      <div>
        <Grid className={classes.textCenter}>

          <Typography className={classes.racErrorFunction} style={{ fontSize: '16px' }}>
            {t('Term is invalid. Allowable terms are 10 -')} {maximumAllowedTermForMessage}
          </Typography>
        </Grid>
        <Grid className={classes.textCenter} style={{ marginTop: '20px' }}>
          <RACButton
            autoFocus
            variant="contained"
            color="primary"
            className={classes.spacerME2}
            onClick={acceptTermAlert}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const provideSLAData = (value: any) => {
    console.log('received provideSLA', value);
    const roleCode = value.substr(value.length - 3);
    console.log('received provideSLA after trim', roleCode);

    setroleFromSLA(roleCode);
  };

  return (
    <Grid item md={3}>
      {SecondFactorEnabled === true ? (
        <TwoFactorComponent
          // setTwoFactorCancelClick={setTwoFactorCancelClick}
          setTwoFactorCancelClick={SLACancel}
          // setTwoFactorCompleted={setTwoFactorCompleted}
          setTwoFactorCompleted={SLACompleted}
          setRoleFromSLAModule={provideSLAData}
          moduleName={ModuleName}
          CurrentRole={CurrentRole}
          minRole={SLAMinRole}
          throwCurrentPage="addedItem"
          agrRate={Number(agrRate) != Number(initialAgreementRate) ? initialAgreementRate : null}
          agrTerm={Number(agrTerm) != Number(initialAgreementTerm) ? initialAgreementTerm : null}
        />
      ) : null}
      <Typography className={`${classes.title} ${classes.mt2}`} variant="h6">
        {t('Package Items')}
      </Typography>
      <Card className={classes.card}>
        <CardContent className={classes.p1}>
          <Card
            className={`${classes.racBlue} ${classes.card} ${classes.p3} ${classes.pb0}`}
          >
            <BlueCard
              throwPackage={throwPackageValue}
              triggerTemp={temp}
              throwStyle={props.throwStyle}
              selectedPackage={props.selectedPackage}
            />
          </Card>

          <div className={`${classes.mt3}`}>
            <div className={classes.row}>
              <Typography className={classes.title} variant="h6">
                {t('Package Price Tag Total')}
              </Typography>
              <WhiteCard throwStyle={props.throwStyle} />
              <Grid md={12} className={`${classes.mb3} ${classes.flexCenter}`}>
                <Typography variant="caption" className={classes.formLabel}>
                  {t('Pkg Rate')}
                </Typography>

                <Grid
                  className={`${addedItemClassName.inputGroup} ${classes.w50} ${classes.floatRight}`}
                >
                  <Typography className={addedItemClassName.inputGroupText}>
                    $
                  </Typography>

                  <CurrencyInput
                    id="AgrRate"
                    name="AgrRate"
                    value={agrRate}
                    className={shareData.itemPricing[0].packageName?.toLowerCase() == ADD_ON_PACKAGE.toLowerCase() ? `${classes.formControl} ${addedItemClassName.currencyAlign} ${classes.fontSemiBold} ${addedItemClassName.disabledColourAgrRate}` : `${classes.formControl} ${addedItemClassName.currencyAlign} ${classes.fontSemiBold}`}
                    decimalScale={2}
                    decimalsLimit={2}
                    onValueChange={(e) => agrRatechange(e)}
                    onBlur={() => blurFunction('RateChange')}
                    onKeyDown={(e) => RateTermChange('RateChange', e)}
                    disabled={controlCurrencyInput || shareData.itemPricing[0].packageName?.toLowerCase() == ADD_ON_PACKAGE.toLowerCase()}
                  />
                </Grid>
              </Grid>
              <Grid md={12} className={`${classes.mb3} ${classes.flexCenter}`}>
                <Typography variant="caption" className={classes.formLabel}>
                  {t('Pkg Term')}
                </Typography>

                <Grid
                  className={`${addedItemClassName.inputGroup} ${classes.w50} ${classes.floatRight}`}
                >
                  <RACTextbox
                    id="AgrTerm"
                    type="number"
                    name="itemNo"
                    isCurrency={false}
                    digitFormat="normal"
                    className={shareData.itemPricing[0].packageName?.toLowerCase() == ADD_ON_PACKAGE.toLowerCase() ? `${addedItemClassName.disabledColourAgrRate}` : ''}
                    value={agrTerm}
                    OnChange={(e) => agrTermchange(e.target.value)}
                    Onblur={() => blurFunction('TermChange')}
                    disabled={shareData.itemPricing[0].packageName?.toLowerCase() == ADD_ON_PACKAGE.toLowerCase()}
                    //OnKeydown={(e) => checkAgrTermChange(e)}
                    OnKeydown={(e) => RateTermChange('TermChange', e)}
                  //onKeydown={(e) => checkAgrTermChange(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid md={12}>
                <Typography
                  variant="subtitle2"
                  className={`${classes.racpadLink} ${classes.textRight} ${classes.underlinetxtDecoration}`}
                  data-testid="SetToDefault"
                  style={{ cursor: 'pointer' }}
                  onClick={setDefault}
                >
                  {t('Set to Default')}
                </Typography>
              </Grid>
            </div>
          </div>
          <Card
            className={`${classes.card} ${classes.racSkyBlue} ${classes.p3}`}
          >
            <Grid
              md={12}
              className={`${addedItemClassName.agrAddedTotal} ${classes.mb2}`}
            >
              <Typography
                variant="caption"
                className={`${classes.textBlue1} ${classes.fs7} ${classes.fontSemiBold}`}
              >
                {t('Cash Price')}
              </Typography>

              <Typography
                variant="caption"
                className={`${classes.textBlue1} ${classes.font18} ${classes.fontBold}`}
                style={{ fontSize: '18px' }}
              >
                ${cashPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </Typography>
            </Grid>
            <Grid
              md={12}
              className={`${addedItemClassName.agrAddedTotal} ${classes.mb2}`}
            >
              <Typography
                variant="caption"
                className={`${classes.textBlue1} ${classes.fs7} ${classes.fontSemiBold}`}
              >
                {t('Package Total')}
              </Typography>

              <Typography
                variant="caption"
                className={`${classes.textBlue1} ${classes.font18} ${classes.fontBold}`}
                style={{ fontSize: '18px' }}
              >
                ${agrTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </Typography>
            </Grid>
          </Card>
        </CardContent>
      </Card>

      <RACModalCard
        isOpen={invalidTerm}
        maxWidth="xs"
        borderRadius={'26px !important'}

      // children={invalidTermDiv()}
      >
        {invalidTermDiv('Invalid term')}
      </RACModalCard>

      <RACModalCard
        isOpen={enableZeroValidate}
        maxWidth="xs"
        borderRadius={'25px !important'}

      //children={enableZeroValidatediv()}
      >
        {invalidTermDiv('Invalid rate. Rate should be greater than $0.00')}
      </RACModalCard>

      <RACModalCard
        isOpen={needSLA.needSLAController}
        maxWidth="xs"
        borderRadius={'25px !important'}
      //children={enableZeroValidatediv()}
      >
        {SLAModal(thresHoldExceptionMessage)}
      </RACModalCard>
      <RACModalCard
        isOpen={openRateAlertModal}
        maxWidth={'sm'}
        borderRadius="25px !important"
        //eslint-disable-next-line react/no-children-prop
        children={openRateAlert()}
      ></RACModalCard>
      {/* Invalid Term Popup */}
      <RACModalCard
        isOpen={invalidTermPopup}
        maxWidth={'sm'}
        borderRadius="25px !important"
        //eslint-disable-next-line react/no-children-prop
        children={openTermAlert()}
      ></RACModalCard>
      {/* Invalid Term user popup */}
      <RACModalCard
        isOpen={openTermAlertModal}
        maxWidth={'sm'}
        borderRadius="25px !important"
        //eslint-disable-next-line react/no-children-prop
        children={openRateAlertUser()}
      ></RACModalCard>
      {/* MX Store Rate Increase popup */}
      <RACModalCard
        isOpen={mxRateIncreasePopup}
        maxWidth={'sm'}
        borderRadius="25px !important"
        //eslint-disable-next-line react/no-children-prop
        children={openMxRateIncreaseAlert()}
      ></RACModalCard>
    </Grid>
  );
};

export default AddedItem;
